import React from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
interface FocusAreaProps {
  selected: string;
  onSelect: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const FocusArea = ({
  selected,
  onSelect,
  onNext,
  onBack
}: FocusAreaProps) => {
  const focusOptions = [{
    value: 'stress',
    label: 'Stress relief',
    emoji: '🌿',
    description: 'Calm your mind and body'
  }, {
    value: 'strength',
    label: 'Strength',
    emoji: '💪',
    description: 'Build muscle and power'
  }, {
    value: 'cardio',
    label: 'Cardio',
    emoji: '❤️',
    description: 'Boost your heart rate'
  }, {
    value: 'mix',
    label: 'Mix',
    emoji: '🎲',
    description: 'Variety of exercises'
  }];
  return <div className="flex flex-col h-full p-6" data-id="element-735">
      <div className="mb-6" data-id="element-736">
        <button onClick={onBack} className="text-gray-500 mb-4" data-id="element-737">
          ← Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-738">
          What's most important to you right now?
        </h1>
        <p className="text-gray-600" data-id="element-739">
          This helps us choose the right exercises for you.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-740">
        {focusOptions.map(option => <Card key={option.value} onClick={() => onSelect(option.value)} active={selected === option.value} className="p-4 flex flex-col items-center text-center" data-id="element-741">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-2 text-2xl" data-id="element-742">
              {option.emoji}
            </div>
            <h3 className="font-medium" data-id="element-743">{option.label}</h3>
            <p className="text-gray-500 text-xs mt-1" data-id="element-744">{option.description}</p>
          </Card>)}
      </div>
      <div className="mt-auto" data-id="element-745">
        <Button onClick={onNext} variant="primary" fullWidth disabled={!selected} className={!selected ? 'opacity-50 cursor-not-allowed' : ''} data-id="element-746">
          Continue
        </Button>
      </div>
    </div>;
};